import { compareNotes } from './TonalUtils'

export const notesToScale = (notes: string[], octave = 4) => {
	if (!notes.length) return []

	const notes2 = notes.map((n, i) => {
		if (i > 0 && compareNotes(notes[i - 1], n) === -1)
			octave++

		return { name: n + octave, duration: '8n', delay: '+0:0:' + i }
	})

	if (compareNotes(notes[notes.length - 1], notes[0]) === -1)
		octave++

	notes2.push(({ name: notes[0] + octave, duration: '8n', delay: '+0:0:' + notes.length }))

	return notes2
}

export const notesToChord = (notes: string[], octave = 4) => {
	const notes2 = notes.map((n, i) => {

		// console.log({ n1: i > 0 && notes[i - 1], n2: n, compare: i > 0 && compareNotes(notes[i - 1], n) })

		if (i > 0 && compareNotes(notes[i - 1], n) === -1)
			octave++

		return { name: n + octave, duration: '8n' }
	})

	// console.log({ notes2 })

	return notes2
}